export default {
    state: {
        product_id: null,
        errors: {},
        brands: [],
        categories: [],
        form: {
            code: '',
            name: '',
            brand_id: '',
            category_id: '',
            sub_category_id: '',
            vacant_from: 'null',
            product_unit_id: '',
            default_usage_unit_id: '',
            product_cost: '',
            alert_quntity: '',
            opening_stock: '',
            product_detail: ''
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'brand', label: 'Brand', tdClass: 'text-muted'},
                {key: 'category', label: 'Category', tdClass: 'text-muted'},
                {key: 'expire_date', label: 'Expire Date', tdClass: 'text-muted'},
                {key: 'unit', label: 'Unit', tdClass: 'text-muted'},
                {key: 'usage_unit', label: 'Usage Unit', tdClass: 'text-muted'},
                {key: 'purchase_unit', label: 'Purchase Unit', tdClass: 'text-muted'},
                {key: 'cost', label: 'Cost', tdClass: 'text-muted'},
                {key: 'alert_quantity', label: 'Alert Quantity', tdClass: 'text-muted'},
                {key: 'opening_stock', label: 'Opening Stock', tdClass: 'text-muted'},
                {key: 'image', label: 'Image', tdClass: 'text-muted'},
                {key: 'details', label: 'Details', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },

        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
    },

    getters: {
        getProductTableFields: state => state.table.fields,

        getProductMeta: state => state.meta,

        getProductForm: state => state.form,

        getProductErrors: state => state.errors,
    },

    mutations: {
        resetProductsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setProducts: (state, payload) => {
            state.categories = payload;
        },

        setProductsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setProductForm: state => {
            state.form = {
                code: '',
                name: '',
                brand_id: '',
                category_id: '',
                sub_category_id: '',
                vacant_from: 'null',
                product_unit_id: '',
                default_usage_unit_id: '',
                product_cost: '',
                alert_quntity: '',
                opening_stock: '',
                product_detail: ''
            };

            state.errors = {};
        },

        setProductErrors: (state, payload) => {
            state.errors = payload;
        },

    },

    actions: {
        fetchProducts: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const product = {
                "data": [
                    {
                        "product_id": 1,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile",
                                "brand": "i-phone 6s",
                                "category": "electronics",
                                "sub-category": "Hand Held",
                                "expire_date": "11-04-2007",
                                "unit": "pieces",
                                "usage_unit": "piece",
                                "purchase_unit": "piece",
                                "cost": "$20000",
                                "alert_quantity": "1",
                                "opening_stock": "10",
                                "image": "image1.jpg",
                                "details": "i3-6100 processor",
                                "note": "gpu-2080 ti",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "product\/1"}
                    },
                    {
                        "unit_id": 2,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Steak",
                                "brand": "A5 wagyu",
                                "category": "grocerries",
                                "sub-category": "Food",
                                "expire_date": "04-11-2021",
                                "unit": "boxes",
                                "usage_unit": "boxes",
                                "purchase_unit": "boxes",
                                "cost": "$20.00",
                                "alert_quantity": "100",
                                "opening_stock": "1000",
                                "image": "image2.jpg",
                                "details": "Canola Oil",
                                "note": "BBQ flavor",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "product\/2"}
                    },
                    {
                        "unit_id": 3,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Apple",
                                "brand": "i-phone Xs",
                                "category": "electronics",
                                "sub-category": "Hand Held",
                                "expire_date": "11-04-2007",
                                "unit": "pieces",
                                "usage_unit": "piece",
                                "purchase_unit": "piece",
                                "cost": "$100000",
                                "alert_quantity": "4",
                                "opening_stock": "5",
                                "image": "image3.jpg",
                                "details": "i7-7500 processor",
                                "note": "snapdragob 765",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "product\/3"}
                    }
                ],
                "links": {
                    "self": "\/product",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/product?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/product?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/product?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/product",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setProducts', product);

                commit('setProductsMeta', product.meta);

                resolve(product);
            });
        },

        fetchEditProduct: ({state, commit}, product_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + product_id + '/edit')
                    .then(response => {
                        state.product_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitProduct: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateProduct: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.product_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteProduct: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.product_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
